import { axiosInstance, getCookie, axiosEventsInstance } from './utilities';
import { handleApiErrors } from './helperFunctions';

export const apiCall = async function ({
  method = 'get',
  api,
  body,
  isBaseUrl = true,
  isEvent = false,
  setResponseType = '',
}) {
  return new Promise((resolve, reject) => {
    // setting token
    const token = getCookie('u_auth');
    if (setResponseType) {
      axiosInstance.defaults.responseType = setResponseType;
    }
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${
      token || (localStorage.getItem('authToken') ? localStorage.getItem('authToken') : '')
    }`;
    if (!isBaseUrl) {
      axiosInstance.defaults.headers.common['Content-Type'] = 'image/png';
    }
    // if (isEvent) {
    //   axiosInstance.defaults.headers.common['x-requested-with'] = 'XMLHttpRequest';
    // } else {
    //   delete axiosInstance.defaults.headers.common['x-requested-with'];
    // }

    axiosInstance[method](
      `${isBaseUrl ? getMicroServiceURL(isEvent) : ''}${api}`,
      body || '',
    )
      .then((data) => {
        resolve(statusHelper(data));
      })
      .catch((error) => {
        try {
          if (error.response) {
            reject(statusHelper(error.response));
          } else {
            reject(error);
          }
        } catch (err) {
          reject(err);
        }
      });
  });
};

export const apiEventCall = async function ({
  method = 'get',
  api,
  body,
  isBaseUrl = true,
  isEvent = false,
}) {
  return new Promise((resolve, reject) => {
    // setting token
    const token = getCookie('u_auth');
    axiosEventsInstance.defaults.headers.common.Authorization = `Bearer ${
      token || (localStorage.getItem('authToken') ? localStorage.getItem('authToken') : '')
    }`;
    if (!isBaseUrl) {
      axiosEventsInstance.defaults.headers.common['Content-Type'] = 'image/png';
    }
    axiosEventsInstance.defaults.headers.common['x-requested-with'] = 'XMLHttpRequest';

    axiosEventsInstance[method](
      `${isBaseUrl ? getMicroServiceURL(isEvent) : ''}${api}`,
      body || '',
    )
      .then((data) => {
        resolve(statusHelper(data));
      })
      .catch((error) => {
        try {
          if (error.response) {
            reject(statusHelper(error.response));
          } else {
            reject(error);
          }
        } catch (err) {
          reject(err);
        }
      });
  });
};

const statusHelper = (data) => {
  if (data.status == 401 || data.data.error === 'token_invalid') {
    handleApiErrors(data.status, data?.data?.message);
  } else {
    return data;
  }
};

let getMicroServiceURL = (isEvent) => {
  let finalURL = '';
  if (!isEvent) {
    finalURL = process.env.NODE_ENV == 'development' ? 'https://devapis.ketto.org/' : 'https://sip.ketto.org/';
  } else {
    finalURL = process.env.NODE_ENV == 'development' ? 'https://devsip.ketto.org/' : 'https://sip.ketto.org/';
  }
  return finalURL;
};

export const apiServiceURL = (baseURL = 'normal') => getMicroServiceURL(baseURL);
